import { Attachment, AttType } from 'src/graphql/generated';
import { CPRFormData } from 'src/components/Pages/CPR/types';
import { prepareAttachments } from 'src/components/Attachments/utils';
import { useUploadAttachments } from 'src/hooks/useUploadAttachments';

export const useCprAttachmentsUpload = () => {
  const uploadCPRFiles = useUploadAttachments(AttType.Cprattachments);
  const uploadPCiles = useUploadAttachments(AttType.Cprpcattachments);
  const processAttachments = async (
    data: CPRFormData
  ): Promise<{
    aggregatedCprAttachments: Attachment[];
    aggregatedPcAttachments: Attachment[];
  }> => {
    // Separate new Files vs existing attachments
    const localCprFiles = data.cprAttachements.filter((a): a is File => a instanceof File);

    const previousCprAttachments = data.cprAttachements.filter(
      (a): a is Attachment => !(a instanceof File)
    );

    const localPcFiles = data.cprPcAttachments.filter((a): a is File => a instanceof File);

    const previousPcAttachments = data.cprPcAttachments.filter(
      (a): a is Attachment => !(a instanceof File)
    );

    try {
      // Upload in parallel
      const [newCprAttachments, newPcAttachments] = await Promise.all([
        localCprFiles.length ? uploadCPRFiles(localCprFiles) : Promise.resolve([]),
        localPcFiles.length ? uploadPCiles(localPcFiles) : Promise.resolve([])
      ]);

      return {
        aggregatedCprAttachments: [
          ...prepareAttachments(previousCprAttachments),
          ...prepareAttachments(newCprAttachments as Attachment[])
        ],
        aggregatedPcAttachments: [
          ...prepareAttachments(previousPcAttachments),
          ...prepareAttachments(newPcAttachments as Attachment[])
        ]
      };
    } catch (error) {
      throw error; // let component handle error
    }
  };

  return { processAttachments };
};
